import { clsx, type ClassValue } from 'clsx';

/** Joins conditional class names. */
export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
